// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5440":"css/admin-app.7070","9624":"css/app.7070"}[chunkId] + ".css";
};